import React from "react";
import "../CustomCSS/FloatingBookButton.css";
import { FaCalendarCheck } from "react-icons/fa";

const FloatingBookButton = ({ isModalOpen, setIsModalOpen }) => {
  return (
    <button
      className={`floating-book-btn ${isModalOpen ? "active" : ""}`}
      onClick={() => setIsModalOpen(true)}
    >
      <FaCalendarCheck size={20} />
      <span>Book Appointment</span>
    </button>
  );
};

export default FloatingBookButton;
